const translations = {
    batteryNameFieldPlaceholder: 'Battery Name',
    serialNumberFieldPlaceholder: 'Serial Number'
};

export default translations;
